export default __webpack_public_path__ + "static/media/index-partner.db4199b0.png";